export default __webpack_public_path__ + "static/6Oxygen-Post-Codes-Final-e5f78f112e3b23e4218b5c4c32774520.pdf";